import { render, staticRenderFns } from "./GenerarPrograma.vue?vue&type=template&id=533397cd&scoped=true"
import script from "./GenerarPrograma.vue?vue&type=script&lang=js"
export * from "./GenerarPrograma.vue?vue&type=script&lang=js"
import style0 from "./GenerarPrograma.vue?vue&type=style&index=0&id=533397cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533397cd",
  null
  
)

export default component.exports